import React, { useState } from 'react';
import { Box, Card, Typography, Button, Snackbar, Alert, CircularProgress } from '@mui/material';
import { ListPropertyProvider, useListPropertyContext } from '../../../../contexts/ListPropertyContext';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import AssetUpload from '../../../../components/AssetUpload/AssetUpload';
import PropertyTypeChips from './PropertyTypeChips/PropertyTypeChips';
import PropertyDetailsSection from './PropertyDetailsSection/PropertyDetailsSection';
import AddressSection from './AddressSection/AddressSection';
import FeaturesSection from './FeaturesSection/FeaturesSection';
import PersonalInfoSection from './PersonalInfoSection/PersonalInfoSection';
import { listingSectionStyles as styles } from './ListingSection.styles';
import { submitPropertyForm } from '../../../../utils/submitPropertyForm';

const ListingSectionContent = () => {
  const { formData } = useListPropertyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      await submitPropertyForm(formData);
      setSnackbarMessage('Thank you for your submission! Your message has been successfully sent');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Form submission error:', error);
      setSnackbarMessage('Error sending your message, please try again later!');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <>
      <Card sx={styles.card}>
        <Typography sx={styles.title}>List Your Property</Typography>

        <Box sx={styles.divider} />
        {/* Property Type Section */}
        <Box sx={styles.section}>
          <SectionTitle>Property Type</SectionTitle>
          <PropertyTypeChips />
        </Box>

        <Box sx={styles.divider} />
        {/* Property Details Section */}
        <Box sx={styles.section}>
          <SectionTitle>Property Details</SectionTitle>
          <PropertyDetailsSection />
        </Box>

        <Box sx={styles.divider} />

        {/* Photos & Videos Section */}
        <Box sx={styles.section}>
          <SectionTitle>Photos & Videos</SectionTitle>
          <AssetUpload />
        </Box>

        <Box sx={styles.divider} />

        {/* Address Section */}
        <Box sx={styles.section}>
          <SectionTitle>Address</SectionTitle>
          <AddressSection />
        </Box>

        <Box sx={styles.divider} />

        {/* Features Section */}
        <Box sx={styles.section}>
          <SectionTitle>Features</SectionTitle>
          <FeaturesSection />
        </Box>

         <Box sx={styles.divider} />
        {/* Personal Info Section */}
        <Box sx={styles.section}>
          <SectionTitle>Personal Info</SectionTitle>
          <PersonalInfoSection />
        </Box>


        {/* Submit Button */}
        <Button
          variant="contained"
          disableElevation
          sx={styles.submitButton}
          onClick={handleSubmit}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
        >
          {isSubmitting ? 'Submitting...' : 'Submit for Approval'}
        </Button>
      </Card>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

const ListingSection = () => {
  return (
    <ListPropertyProvider>
      <ListingSectionContent />
    </ListPropertyProvider>
  );
};

export default ListingSection;

